import { renderCalcPos, onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const calculatedMaterialLengthColumn: CalculationColumn = {
    dataIndex: ['calculated', 'materialLength'],
    title: 'Длина роля',
    width: 50,
    onCell: onAnyStandardCell,
    render: renderCalcPos(r => Math.round((r.calculated?.materialLength || 0) * 1000) / 1000),
}
